// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"bc0f0bee","921":"1d2711c4"}[chunkId] + ".chunk.js";
};